<template>
  <div>
    <PublicLayout>
      <header
        class="header"
        :style="{
          backgroundImage: `url(${require('@/assets/public/images/company/header.jpg')})`,
        }"
      >
        <div class="container">
          <h1>Hồ sơ công ty<!--企業概要--></h1>
        </div>
      </header>
      <HeaderNav activeLink="company" />
      <!-- main-section -->
      <section class="main-section">

        <!-- m-sec -->
        <section class="m-sec">
          <div class="container">
            <h2 class="section-title text-primary">Hồ sơ công ty<!--企業概要--></h2>
            <h2 class="section-title">công ty việt nam<!--越南分公司--></h2>
            <table class="table light-table">
              <tr>
                <th>Tên công ty<!--公司名稱--></th>
                <td>CÔNG TY TNHH VIỆT HƯNG VƯỢNG<!--越南公司名稱:--></td>
              </tr>
              <tr>
                <th>Địa chỉ<!--地址--></th>
                <td>27 Nguyễn văn thương phường 25 Bình Thạnh<!--越南公司地址--></td>
              </tr>
              <tr>
                <th>Tiêu biểu<!--代表者--></th>
                <td>Tổng thống Miki Koda<!--社長 幸田 望希--></td>
              </tr>
              <tr>
                <th>Thời gian thành lập<!--成立時間--></th>
                <td>tháng 7 năm 2022<!--2022年7月--></td>
              </tr>
              <tr>
                <th>TEL</th>
                <td>0348847798</td>
              </tr>
            </table>
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3919.1442088612816!2d106.71765827435128!3d10.800265158754977!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x317528a635f2dd89%3A0x894229a069b3a336!2zTmd1eeG7hW4gVsSDbiBUaMawxqFuZy8yNyBI4bq7bSAxNTIsIEtodSBwaOG7kSAyLCBCw6xuaCBUaOG6oW5oLCBI4buTIENow60gTWluaCwg6LaK5Y2X!5e0!3m2!1szh-TW!2stw!4v1733464969328!5m2!1szh-TW!2stw"
              width="100%"
              height="450"
              style="border: 0"
              allowfullscreen=""
              loading="lazy"
            ></iframe>
            
          </div>
        </section>

        <!-- m-sec -->
        <section class="m-sec">
          <div class="container">
            <h2 class="section-title">Chi nhánh Đài Loan và Hiệp hội Đài Bắc<!--台灣分公司暨台北會館--></h2>
            <table class="table light-table">
              <tr>
                <th>Tên công ty<!--公司名稱--></th>
                <td>Nissho Fudizhi (Co., Ltd.) Chi nhánh Đài Loan<!--日商富地滋(股)台灣分公司--></td>
              </tr>
              <tr>
                <th>Địa chỉ<!--地址--></th>
                <td>Số 465, Đường Bannan, Quận Trung Hòa, Thành phố Tân Bắc<!--新北市中和區板南路465號--></td>
              </tr>
              <tr>
                <th>Tiêu biểu<!--代表者--></th>
                <td>Tổng thống Miki Koda<!--社長 幸田 望希--></td>
              </tr>
              <tr>
                <th>Thời gian thành lập<!--成立時間--></th>
                <td>tháng 8 năm 2004<!--2004年8月--></td>
              </tr>
              <tr>
                <th>TEL</th>
                <td>+886-2-2563-6556</td>
              </tr>
              <tr>
                <th>FAX</th>
                <td>+886-2-2563-6555</td>
              </tr>
            </table>
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3615.832366730204!2d121.48625687537562!3d25.005811477834683!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3442a82b737efe7d%3A0x8b57abcb482a458b!2zMjM15paw5YyX5biC5Lit5ZKM5Y2A5p2_5Y2X6LevNDY16Jmf!5e0!3m2!1szh-TW!2stw!4v1706868567729!5m2!1szh-TW!2stw"
              width="100%"
              height="450"
              style="border: 0"
              allowfullscreen=""
              loading="lazy"
            ></iframe>
            <div>
              <h4>●Thông tin giao thông<!--交通資訊-->●</h4>
              <ul>
                <li>
                  <p>◎Tuyến MRT-Circular: Ga Y13 Qiaohe, mất khoảng 3 phút đi bộ đến đích (Tòa nhà Trung tâm Khoa học và Công nghệ Đài Loan)
                    <!--捷運-環狀線：Y13 橋和站步行約3分鐘即到達目的地 (台灣科技廣場大樓)-->
                  </p>
                </li>
                <li>
                  ◎xe buýt:<!--公車:-->
                  <ul>
                    <li>
                      Ngã tư Bannan: Xanh 18
                      <!--板南路口：藍18-->
                    </li>
                    <li>
                      Ga tàu điện ngầm Qiaohe: 262, 897, 982
                      <!--捷運橋和站：262、897、982-->
                    </li>
                    <li>
                      Nhà máy bảo trì Zhonghe: khoảng 5, 262, 262, 897
                      <!--中和保養廠：5、262、262區間、897-->
                    </li>
                  </ul>
                </li>
                <p/>
                <li>
                  <p>◎Thông tin bãi đậu xe gần đó: Đài Loan Khoa học và Công nghệ Plaza B1-Bãi đậu xe Unicom Đài Loan (Qiaohe Field)
                    <!--附近停車資訊：台灣科技廣場 B1-台灣聯通停車場 (橋和場)-->
                  </p>
                </li>
              </ul>
            </div>
          </div>
        </section>
        <!-- m-sec -->
        <section class="m-sec">
          <div class="container">
            <h2 class="section-title">Hội quán Đài Trung<!--台中會館--></h2>
            <table class="table light-table">
              <tr>
                <th>Địa chỉ<!--地址--></th>
                <td>
                  3F-1, Số 61, Đoạn 2, Đường Gongyi, Quận Nam Đồn, Thành phố Đài Trung
                  <!--台中市南屯區公益路二段61號3樓之1-->
                </td>
              </tr>
              <tr>
                <th>TEL</th>
                <td>+886-4-2320-3588</td>
              </tr>
              <tr>
                <th>FAX</th>
                <td>+886-4-2320-3589</td>
              </tr>
            </table>
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d7281.201865954425!2d120.650478!3d24.150649!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x34693d965c93dccd%3A0x1779a393b0d63c39!2sNo.%2061%2C%20Section%202%2C%20Gongyi%20Road%2C%20Nantun%20District%2C%20Taichung%20City%2C%20408!5e0!3m2!1sen!2stw!4v1618135361247!5m2!1sen!2stw"
              width="100%"
              height="450"
              style="border: 0"
              allowfullscreen=""
              loading="lazy"
            ></iframe>
          </div>
        </section>
        <!-- m-sec -->
        <section class="m-sec">
          <div class="container">
            <h2 class="section-title">Hội quán Cao Hùng<!--高雄會館--></h2>
            <table class="table light-table">
              <tr>
                <th>Địa chỉ<!--地址--></th>
                <td>
                  12F-2, Số 260, Đường Trung Sơn 2, Quận Qianzhen, Thành phố Cao Hùng
                  <!--高雄市前鎮區中山二路260號12樓之2-->
                </td>
              </tr>
              <tr>
                <th>TEL</th>
                <td>+886-7-537-2626</td>
              </tr>
              <tr>
                <th>FAX</th>
                <td>+886-7-537-3636</td>
              </tr>
            </table>
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3683.084862507133!2d120.30292131434797!3d22.613305985161833!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x346e04b8ea700701%3A0x1108ff62a6d2be60!2z5pel5ZWG5a-M5Zyw5ruLKOiCoSnpq5jpm4TmnIPppKg!5e0!3m2!1sen!2stw!4v1618135448168!5m2!1sen!2stw"
              width="100%"
              height="450"
              style="border: 0"
              allowfullscreen=""
              loading="lazy"
            ></iframe>
          </div>
        </section>
        <!-- m-sec -->
        <section class="m-sec">
          <div class="container">
            <h2 class="section-title">Trụ sở chính Nhật Bản<!--日本總公司--></h2>
            <table class="table light-table">
              <tr>
                <th>Tên công ty<!--公司名稱--></th>
                <td>フォーデイズ株式会社</td>
              </tr>
              <tr>
                <th>Địa chỉ<!--地址--></th>
                <td>
                  【東京本社】〒103-0016東京都中央区日本橋小網町6-7
                  第2山万ビル<br />【本店】〒103-0025東京都中央区日本橋茅場町1-13-21
                </td>
              </tr>
              <tr>
                <th>Tiêu biểu<!--代表者--></th>
                <td>Giám đốc đại diện và Chủ tịch Keiko Wada<!--代表取締役社長 和田佳子--> </td>
              </tr>
              <tr>
                <th>Thời gian thành lập<!--成立時間--></th>
                <td>tháng 4 năm 1997<!--1997年4月--></td>
              </tr>
              <tr>
                <th>thủ đô<!--資本--></th>
                <td>45 triệu yên<!--4500萬日圓--></td>
              </tr>
              <tr>
                <th>Tổng quan về hoạt động kinh doanh<!--業務活動概況--></th>
                <td>Phát triển và kinh doanh thực phẩm sức khỏe và mỹ phẩm
                  <!--開發及銷售保健食品和化妝品-->
                </td>
              </tr>
              <tr>
                <th>doanh thu hàng năm<!--年營業額--></th>
                <td>32,2 tỷ yên (tháng 3 năm 2020)<!--322億 日元（2020年3月）--></td>
              </tr>
              <tr>
                <th>Tổng số nhân viên<!--員工總人數--></th>
                <td>264</td>
              </tr>
            </table>
          </div>
        </section>
      </section>
      <!-- main-section -->
    </PublicLayout>
  </div>
</template>

<script>
import PublicLayout from "../../components/public/PublicLayout";
import HeaderNav from "../../components/public/headerNav/CompanyHeaderNav";
export default {
  name: "CompanyScreen",
  components: {
    PublicLayout,
    HeaderNav,
  },
};
</script>
